import React from "react";
import { Box } from "@cloudscape-design/components";

interface DeploymentOverviewProps {
    title: string;
    description: string;
}

export const DeploymentOverview: React.FC<DeploymentOverviewProps> = ({ title, description }) => {
    return (
        <div>
            <h4>{title}</h4>
            <Box>{description}</Box>
        </div>
    );
};